<template>

    <div class="animated fadeIn">

        <b-row class="py-2">

            <b-card header="Nueva Respuesta Tipo" class="w-100">

                <query-answer-type-form
                    class="px-3"
                    :renderDeleteButton="false"
                    :renderSaveButton="mixinCheckPermission('QUERY_ANSWER_TYPE_NEW')"
                    @submit-query-answer-type="addQueryAnswerType($event)">
                </query-answer-type-form>

            </b-card>

        </b-row>

    </div>

</template>

<script>

    import QueryAnswerTypeForm from './QueryAnswerTypeForm';
    import {createQueryAnswerType} from '@/api/query-answer-type-api';

    export default {
        name: "AddQueryAnswerType",
        components: {QueryAnswerTypeForm},
        comments: {
            QueryAnswerTypeForm
        },

        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/queries/answer-types/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
            };
        },

        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
        },

        methods: {

            addQueryAnswerType(queryAnswerType) {

                this.$_loadingMixin_showLoading();

                createQueryAnswerType(queryAnswerType)
                    .then(() => {
                    this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                    this.$_loadingMixin_hideLoading();
                    this.$router.push({path: '/queries/answer-types/list'});
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                        this.$_loadingMixin_hideLoading();
                    });
            }
        }
    }
</script>